export default "__VITE_ASSET__5fdae53b__$_?component__"